import React, { useCallback } from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'
import SubmitButton from '../../Form/SubmitButton'
import MinimalisticTrashCanIcon from '../../../Assets/Images/icons/minimalisticTrashCan'
import InfoRows from '../blocks/InfoRows/InfoRows'
import ColorSelect from '../../Form/SelectDashboard/types/ColorSelect/ColorSelect'
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator'

const ShapeSettingsModalView = ({
  colorValue,
  setColorValue,
  onDelete,
  onClose,
  positionInsideParent,
  classes,
  infoRows,
  showDeleteButton,
  editingBlocked,
  saving,
  children,
}) => {
  const modalClickHandler = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
  })

  return (
    <section
      onClick={modalClickHandler}
      className={classes.wrapper}
      style={positionInsideParent}
    >
      {!editingBlocked && (
        <section className={classes.section}>
          <div className={classes.colorSelectWrapper}>
            <ColorSelect value={colorValue} onChange={setColorValue} />
          </div>
          {showDeleteButton && (
            <div className={classes.buttonIcon} onClick={onDelete}>
              <MinimalisticTrashCanIcon />
            </div>
          )}
        </section>
      )}
      <section>{children}</section>
      <InfoRows data={infoRows} />
      <footer className={classes.footer}>
        <SubmitButton
          value="Close"
          onClick={onClose}
          className="ShapeSettingsModalView__button ShapeSettingsModalView__button_cancel"
        />
      </footer>
      {saving && (
        <div className={classes.loadingIndicatorWrapper}>
          <LoadingIndicator />
        </div>
      )}
    </section>
  )
}

export default injectStyles(styles)(ShapeSettingsModalView)



// WEBPACK FOOTER //
// ./src/Components/ShapeSettingsModal/component/ShapeSettingsModalView.js